export default __webpack_public_path__ + "static/media/goggles-icon.5910fdbe.svg";